import { render, staticRenderFns } from "./LogoImageCropper.vue?vue&type=template&id=5a775bb8"
import script from "./LogoImageCropper.vue?vue&type=script&lang=js"
export * from "./LogoImageCropper.vue?vue&type=script&lang=js"
import style0 from "./LogoImageCropper.vue?vue&type=style&index=0&id=5a775bb8&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports